import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NutzerService } from 'src/app/service/nutzer.service';

/** Systemweite Sicherheitseinstellungen (nur SU/ADM) */
@Component({
  selector: 'app-view-security-settings',
  templateUrl: './view-security-settings.component.html',
  styleUrls: ['./view-security-settings.component.scss']
})
export class ViewSecuritySettingsComponent implements OnInit {

  public mfaPflicht = false;
  public loading = true;
  public saving = false;

  constructor(
    private nutzerService: NutzerService,
    private toast: ToastrService
  ) { }

  async ngOnInit() {
    try {
      this.mfaPflicht = await this.nutzerService.getMfaPflicht();
    } catch (error) {
      this.toast.error(error, "Fehler");
    }
    this.loading = false;
  }

  public async saveMfaPflicht(aktiv: boolean) {
    this.saving = true;
    try {
      const msg = await this.nutzerService.setMfaPflicht(aktiv);
      this.mfaPflicht = aktiv;
      this.toast.success(msg, "Erfolgreich");
    } catch (error) {
      this.mfaPflicht = !aktiv;
      this.toast.error(error, "Fehler");
    }
    this.saving = false;
  }
}
